module.exports = __webpack_public_path__ + "img/stroke.2dae6f04.png";